var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "C1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#69CBF0;}\r\n\t.st1{enable-background:new    ;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4099",
    className: "st0",
    d: "M2,0h16c1.1,0,2,0.9,2,2v16c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.9,11.4c-0.1,0.9-0.4,1.6-1,2.2s-1.4,0.8-2.4,0.8c-1.1,0-2-0.4-2.6-1.1S4,11.5,4,10.2V9.7 c0-0.8,0.1-1.5,0.4-2.2s0.7-1.1,1.2-1.4s1.2-0.5,1.9-0.5c1,0,1.8,0.3,2.4,0.8s0.9,1.3,1,2.2H9.2c0-0.6-0.2-1-0.5-1.2 S8.1,7.1,7.5,7.1c-0.6,0-1,0.2-1.3,0.6s-0.4,1.1-0.4,2v0.6c0,0.9,0.1,1.6,0.4,2s0.7,0.6,1.3,0.6c0.5,0,0.9-0.1,1.2-0.4 s0.4-0.6,0.5-1.2H10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16,14.3h-1.7V7.7l-2,0.6V7l3.5-1.3H16V14.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC1);
export default __webpack_public_path__ + "static/media/C1.7d7158a12c9937a243d6d9cce1eac2a1.svg";
export { ForwardRef as ReactComponent };